// Barrel export for all CDL components

export { default as Button, type ButtonProps } from "./components/Button";
export { default as ButtonDropdown } from "./components/ButtonDropdown";
export {
  default as ToggleGroup,
  type ToggleGroupProps,
} from "./components/ToggleGroup";
export {
  default as ButtonSwitch,
  type ButtonSwitchProps,
} from "./components/ButtonSwitch";
export { default as Checkbox } from "./components/Checkbox";
export { default as Chip } from "./components/Chip";
export { default as DropdownMenu } from "./components/DropdownMenu";
export { default as ElevatedBox } from "./components/ElevatedBox";
export { default as Label } from "./components/Label";
export { List, ListItem } from "./components/List";
export { default as Popover } from "./components/Popover";
export { default as Radio } from "./components/Radio";
export { default as RenderMarkdown } from "./components/RenderMarkdown";
export { TabItem, Tabs } from "./components/Tabs";
export { TextArea, TextAreaFooter } from "./components/TextArea";
export { default as TextInput } from "./components/TextInput";
export { default as Toast } from "./components/Toast";
export { Toggle } from "./components/Toggle";
export { default as Tooltip } from "./components/Tooltip";

// Typography components
export * from "./components/Type";

// Search Mode Icons
export { default as DeepSearchIcon } from "./color_icons/DeepSearchIcon";
export { default as ProSearchIcon } from "./color_icons/ProSearchIcon";
export { default as QuickSearchIcon } from "./color_icons/QuickSearchIcon";

// Plan Tier Icons
export { default as FreeTierIcon } from "./color_icons/FreeTierIcon";
export { default as ProTierIcon } from "./color_icons/ProTierIcon";
export { default as DeepTierIcon } from "./color_icons/DeepTierIcon";
export { default as TeamTierIcon } from "./color_icons/TeamTierIcon";
export { default as EnterpriseTierIcon } from "./color_icons/EnterpriseTierIcon";

// Corpus Type Icons
export { default as AllCorpusIcon } from "./color_icons/AllCorpusIcon";
export { default as MedicalIcon } from "./color_icons/MedicalIcon";

// Study Tag Icons
export { default as RctIcon } from "./color_icons/RctIcon";
export { default as MetaAnalysisIcon } from "./color_icons/MetaAnalysisIcon";
export { default as AnimalTrialIcon } from "./color_icons/AnimalTrialIcon";
export { default as ObservationalStudyIcon } from "./color_icons/ObservationalStudyIcon";
export { default as CaseStudyIcon } from "./color_icons/CaseStudyIcon";
export { default as SystematicReviewIcon } from "./color_icons/SystematicReviewIcon";
export { default as LiteratureReviewIcon } from "./color_icons/LiteratureReviewIcon";
export { default as NonRctIcon } from "./color_icons/NonRctIcon";
export { default as InVitroTrialIcon } from "./color_icons/InVitroTrialIcon";

// Additional Tag Icons
export { default as HighlyCitedIcon } from "./color_icons/HighlyCitedIcon";
export { default as RigorousJournalIcon } from "./color_icons/RigorousJournalIcon";
export { default as VeryRigorousJournalIcon } from "./color_icons/VeryRigorousJournalIcon";
export { default as MeterIcon } from "./color_icons/MeterIcon";
export { default as PreprintIcon } from "./color_icons/PreprintIcon";
export { default as LargeHumanTrialIcon } from "./color_icons/LargeHumanTrialIcon";
export { default as AskPaperIcon } from "./color_icons/AskPaperIcon";
export { default as FullTextIcon } from "./color_icons/FullTextIcon";
export { default as OpenAccessIcon } from "./color_icons/OpenAccessIcon";

// Landing Page Icons
export { default as CompassIcon } from "./color_icons/CompassIcon";
export { default as CraftIcon } from "./color_icons/CraftIcon";
export { default as PeopleIcon } from "./color_icons/PeopleIcon";
export { default as MapIcon } from "./color_icons/MapIcon";
export { default as CuriousCatIcon } from "./color_icons/CuriousCatIcon";

// Misc Icons
export { default as QuestionMarkIcon } from "./color_icons/QuestionMarkIcon";

// Hooks
export { useFloatingTransition } from "./hooks/useFloatingTransition";
